import React from 'react';
import PropTypes from 'prop-types';
import { StyledProviderTab, StyledPatientDetailTab } from './style';

export const ProviderTab = ({ $active, ...rest }) => {
    return <StyledProviderTab {...rest} $active={$active} />;
};

ProviderTab.propTypes = {
    $active: PropTypes.bool,
    rest: PropTypes.object,
};

export const PatientDetailTab = ({ $active, ...rest }) => {
    return <StyledPatientDetailTab {...rest} $active={$active} />;
};

PatientDetailTab.propTypes = {
    $active: PropTypes.bool,
    rest: PropTypes.object,
};
